import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { formatMoney } from "@pages/profile-v2/utils/index.js";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { Box, BoxTitle, Content, ContentTitle, Stake, StakeInput } from "../baseItems";
import Base from "./base";

class Odendibil extends Base {
	componentDidMount() {
		super.componentDidMount();
		this.props.getTypes(
			{
				sessionId: getUser().sessionId,
			},
			() => {
				this.setState({
					selectedCurrency: this.props.selectedWithdraw.currencies[0].currency,
				});
			}
		);
	}

	onSelectPaymentMethod(e) {
		this.setState({
			paymentMethod: e.target.value,
		});
		if (method === "pep") {
			return;
		}
	}

	renderMinMax() {
		const { selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		const currencyToUse = selectedCurrency || selectedWithdraw?.currencies?.[0]?.currency;
		const currency = selectedWithdraw.currencies.filter(
			(item) => item.currency == currencyToUse
		);
		return (
			<Translate>
				{({ translate }) => (
					<div>
						{currency && currency[0] && currency[0].withdraw && (
							<Box>
								<BoxTitle>
									{translate("MIN")} - {translate("MAX")}
								</BoxTitle>
								<Stake>
									{`${formatMoney(
										currency[0].withdraw.min,
										currencyToUse
									)} - ${formatMoney(currency[0].withdraw.max, currencyToUse)}`}
								</Stake>
							</Box>
						)}
					</div>
				)}
			</Translate>
		);
	}

	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<BoxWrapper>
					<FormItem onRegister={() => this.registerField({ name: "account" })}>
						<Box>
							<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
							<StakeInput
								placeholder="...................."
								onChange={this.onEnterValue.bind(this, "account")}
							/>
						</Box>
					</FormItem>
				</BoxWrapper>
			</Content>
		);
	}

	makeExternalPayment() {
		const { stake, account } = this.state;
		const { paymentMethod } = this.props;
		let withdrawData = {
			type: "Odendibil",
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: stake,
				currency: "TRY",
			},
			withdrawType: paymentMethod,
			accountNumber: account,
			language: this.getActiveLanguageCode(),
			note: new Date(),
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}

const mapStateToProps = (state) => ({
	paymentTypes: state.withdraw.odendibilTypes,
});

export default connect(mapStateToProps, null)(Odendibil);
